export default __webpack_public_path__ + "static/media/co2.43eae5b1.svg";